import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FileTypeUtils {
  constructor() { }

  get imageFileFormats(): string[] {
    return [".png",".jpg",".jpeg",".eml",".gif", ".heic", ".heif"];
  }
  get displayImageFileFormats(): string[] {
    return [".png",".jpg",".jpeg",".eml",".gif"];
  }
  get videoFileFormats(): string[] {
    return [".mp4",".m4v",".3gp"];
  }
  get documentFileFormats(): string[] {
    return [".pdf",".txt",".csv",".ppt",".pptx",".xls",".xlsx",".doc",".docx"];
  }
  get audioFileFormats(): string[] {
    return [".mp3",".wav",".m4a"];
  }

  get allFileFormatsForUpload(): string {
    return this.imageFileFormats.concat(this.videoFileFormats, this.documentFileFormats, this.audioFileFormats).join(",");
  }

  isImage(fileName: string) : boolean {
    const fileParts = this.getFileParts(fileName);
    return this.imageFileFormats.includes(fileParts.extension.toLowerCase());
  }

  canDisplayImage(fileName: string) : boolean {
    const fileParts = this.getFileParts(fileName);
    return this.displayImageFileFormats.includes(fileParts.extension.toLowerCase());
  }

  isVideo(fileName: string) : boolean {
    const fileParts = this.getFileParts(fileName);
    return this.videoFileFormats.includes(fileParts.extension.toLowerCase());
  }

  isDocument(fileName: string) : boolean {
    const fileParts = this.getFileParts(fileName);
    return this.documentFileFormats.includes(fileParts.extension.toLowerCase());
  }

  isAudio(fileName: string) : boolean {
    const fileParts = this.getFileParts(fileName);
    return this.audioFileFormats.includes(fileParts.extension.toLowerCase());
  }

  isNoMedia(fileName: string): boolean {
    const fileParts = this.getFileParts(fileName.trim());
    const ext = fileParts.extension.toLowerCase();
    return !this.audioFileFormats.includes(ext)
      && !this.videoFileFormats.includes(ext)
      && !this.documentFileFormats.includes(ext)
      && !this.imageFileFormats.includes(ext)
  }

  getFileParts(fileName: string): { fileName: string; extension: string } {
    const dot = fileName.lastIndexOf('.');
    const extension = dot > 0 ? fileName.substring(dot) : '';
    const fileValue = dot > 0 ? fileName.substring(0, dot) : fileName;

    return { fileName: fileValue, extension };
  }

  getFileIcon(fileName: string): string {
    const { extension } = this.getFileParts(fileName);

    let icon = '/assets/images/files/Filetype_Default.svg';

    switch (extension.toLowerCase()) {
      case '.pdf':
        icon = '/assets/images/files/Filetype_PDF.svg';
        break;
      case '.txt':
        icon = '/assets/images/files/Filetype_TXT.svg';
        break;
      case '.csv':
        icon = '/assets/images/files/Filetype_CSV.svg';
        break;
      case '.eml':
        icon = '/assets/images/files/Filetype_Email.svg';
        break;
      case '.png':
        icon = '/assets/images/files/Filetype_IMG.svg';
        break;
      case '.jpg':
        icon = '/assets/images/files/Filetype_IMG.svg';
        break;
      case '.jpeg':
        icon = '/assets/images/files/Filetype_IMG.svg';
        break;
      case '.gif':
        icon = '/assets/images/files/Filetype_IMG.svg';
        break;
      case '.ppt':
        icon = '/assets/images/files/Filetype_PPT.svg';
        break;
      case '.pptx':
        icon = '/assets/images/files/Filetype_PPT.svg';
        break;
      case '.xls':
        icon = '/assets/images/files/Filetype_XLS.svg';
        break;
      case '.xlsx':
        icon = '/assets/images/files/Filetype_XLS.svg';
        break;
      case '.doc':
      case '.docx':
        icon = '/assets/images/files/Filetype_DOC.svg';
        break;
      case '.mp4':
      case '.m4v':
      case '.3gp':
        icon = '/assets/images/files/Filetype_Video.svg';
        break;
      case '.mp3':
      case '.m4a':
      case '.wav':
        icon = '/assets/images/files/Filetype_Audio.svg';
        break;
      default:
        icon = '/assets/images/files/Filetype_Default.svg';
        break;
    }

    return icon;
  }
}
